import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import moment from 'moment'
import Select from 'react-select'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { Squares } from "react-activity";
import Util from '../../classes/util'
import Alert from '../../components/alert'
import ListaProdutos from '../../components/listaProdutos'

const estadoInicial = {
    ordem: {},

    chave: 0,
    saldoAtual: NaN,
    valorTotal: 0,
    alert: { type: '', msg: '' },

    pessoas: [],
    valores: [],

    produtos: [],
    produtosEscolhidos: [],

    tipo: 'USUARIO',
    tiposOptions: [{ value: "USUARIO", label: "Para Usuário" }, { value: "GENERICO", label: "Genéricos" }],

    pessoasOptions: [],

    textOptions: '',

    unidadesOptions: [],
    usuariosOptions: [],

    ticket: {},

    produtosModal: false,

    usuario: null,
    unidade: null,

    loading: false,
    redirect: false,
}

class AddVoucher extends Component {

    state = {
        ...estadoInicial,
    }


    setEmpresa = () => {
        if (this.props.id === 999999) {
            this.setState({
                empresa: localStorage.getItem('empresaID')
            })
        } else {
            this.setState({
                empresa: this.props.empresa
            })
        }
    }

    componentDidMount = async () => {
        this.setEmpresa();
        if (this.props?.location?.state?.unidade) {
            this.setState({ unidade: this.props.location.state.unidade });
            this.alteraUnidade(this.props.location.state.unidade);
        }
        const { id } = this.props.match?.params;

        if (id != 0) {
            this.setState({ chave: id });
            await this.loadVoucher(id);
            this.alteraUnidade(this.state.unidade);
        }

        this.loadAll();
    }

    loadVoucher = async (id) => {
        await apiEmployee.get(`vouchers/detalhavoucher/${id}`)
            .then(res => {
                this.setState({ voucher: res.data, unidade: res.data.chave_unidade, usuario: res.data.chave_usuario })
            }, (err) => console.error(err));
    }

    loadAll = async () => {
        const unidadesOptions = await apiEmployee.get(`pegarunidades/creditos/${this.props.id}`).then(res => res.data).catch(err => []);
        const usuariosOptions = await apiEmployee.get(`tickets/pegarusuarios/${this.state.empresa}`).then(res => res.data).catch(err => []);

        await this.setState({
            unidadesOptions: [{ label: '---', value: '' }, ...unidadesOptions.map((s) => ({ label: s.Nome, value: s.Chave }))],
            usuariosOptions: [{ label: '---', value: '' }, ...usuariosOptions.map((s) => ({ label: s.nome, value: s.chave }))],
        })
    }

    alteraUnidade = async (unidade) => {
        const tickets = await apiEmployee.get(`tickets/pegarTicketsCreditos/${this.props.id}/${unidade}`).then(res => res.data).catch(err => []);
        const produtos = await apiEmployee.get(`produtoscreditos/unidade/${this.state.empresa}/${unidade}`).then(res => res.data).catch(err => [])

        let saldoAtual = 0;
        if (tickets[0]) {
            tickets.filter((ticket) => ticket.status == 2).forEach((ticket) => {
                saldoAtual += ticket.saldo;
            })
        } else {
            saldoAtual = NaN;
        }

        this.setState({ saldoAtual, produtos, valorTotal: 0, ticket: tickets.find((ticket) => ticket.status == 2) })
    }

    saveVoucher = async () => {
        const vouchersPayload = [];
        const lancamentosPayload = [];
        const creditosItensPayload = [];
        this.state.produtosEscolhidos.forEach((produto) => {
            vouchersPayload.push({
                data: moment().format("YYYY-MM-DD HH:mm:ss"),
                chave_pessoa: this.state.empresa,
                chave_usuario: this.state.usuario,
                chave_unidade: this.state.unidade,
                chave_produto: produto.chave,
                valor: (produto.preco * produto.quantidade),
                saldo: (produto.preco * produto.quantidade),
                tipo: this.state.tipo
            });

            lancamentosPayload.push({
                empresa: 1,
                chave_unidade: this.state.unidade,
                chave_pessoa: this.state.empresa,
                data: moment().format("YYYY-MM-DD HH:mm:ss"),
                valor: (produto.preco * produto.quantidade).toFixed(2),
                chave_produto: produto.chave,
                chave_ticket: this.state.ticket?.chave,
                chave_usuario: this.state.usuario,
                tipo: 'PAGAMENTO'
            });

            creditosItensPayload.push({
                chave: produto.chave_credito,
                disponivel: produto.maxQtd - produto.quantidade
            })
        });

        const creditoPayload = { ...this.state.ticket, data: moment(this.state.ticket)?.format('YYYY-MM-DD'), saldo: (this.state.ticket.saldo - this.state.valorTotal.toFixed(2)) }

        const saved = await apiEmployee.post(`vouchers/salvarvoucher`, {
            vouchersPayload,
            lancamentosPayload,
            creditosItensPayload,
            creditoPayload
        }).then((res) => res.data)
            .catch(err => null);

        if (saved) {
            this.setState({
                redirect: true,
            })
        }
    }

    filterOptions = (item) => {
        if (!this.state.textOptions) {
            return true;
        }

        return item?.label?.toLowerCase().indexOf(this.state.textOptions?.toLowerCase()) != -1;
    }


    render() {
        const validations = []
        validations.push(!isNaN(this.state.saldoAtual) && parseFloat(this.state.saldoAtual?.toFixed(2)) >= parseFloat(this.state.valorTotal?.toFixed(2)));
        validations.push(this.state.tipo !== "USUARIO" || this.state.usuario);
        validations.push(this.state.produtosEscolhidos.length > 0);

        const validForm = validations.reduce((t, a) => t && a)

        return (
            <div>
                {this.state.redirect &&
                    <Redirect to={'/vouchers'} />
                }
                <Alert
                    alert={this.state.alert}
                    setAlert={(value) => this.setState({ alert: value })}
                />

                <Header voltarVoucher />
                <div className='centrom'>
                    <div className={`col-sm-12 col-md-12 col-lg-9 col-xl-9 row ${!this.state.unidade ? "containeralterarpedido" : !this.state.produtosEscolhidos[0] ? "containeralterarproduto" : "containeralterarcardapio"}`} >
                    <Link to={{ pathname: `/vouchers` }} style={{color:"#DE3338", size:"30px", margin:"10px"}}>X</Link>
                        <div className="form_body">
                            {!!this.state.unidade &&
                                <div className="saldo_criar_voucher">
                                    <span>{isNaN(this.state.saldoAtual) ? "Saldo indisponível" : `Saldo atual: R$${Util.formatarDinheiro(this.state.saldoAtual)}`}</span>
                                </div>
                            }
                            <div className='col-12 contcard'>
                                <span>Unidade *</span>

                                <Select placeholder="Selecione a unidade" value={this.state.unidadesOptions.find((opt) => opt.value === this.state.unidade)} options={this.state.unidadesOptions.filter(this.filterOptions).splice(0, 25)} onChange={a => { this.setState({ unidade: a.value, produtosEscolhidos: [] }); this.alteraUnidade(a.value) }} onInputChange={(a) => this.setState({ textOptions: a })} />
                                <span>Não Selecionado</span>
                            </div>
                            {!!this.state.unidade &&
                                <>
                                    {/* <div className='col-12 contcard'>
                                        <div className="voucher_select_titulo">Imprimir vouchers:</div>
                                        <div className="voucher_select_tipo">
                                            {this.state.tiposOptions.map((tipo) => (
                                                <div onClick={() => { this.setState({ tipo: tipo.value, usuario: null }); }} className={`voucher_select ${tipo.value === this.state.tipo ? "voucher_selected" : ""}`}>{tipo.label}</div>
                                            ))}
                                        </div>
                                    </div> */}
                                    <div className='col-12 contcard' >
                                        <div className='botao_produtos'>
                                            <span>Produtos *</span>
                                        </div>
                                        <hr />
                                        <ListaProdutos
                                            onSubmit={(produtos) => { let valor = 0; produtos.map((p) => { valor += p.preco * p.quantidade }); this.setState({ produtosEscolhidos: produtos, valorTotal: valor }) }}
                                            setProdutosEscolhidos={(produtos) => this.setState({ produtosEscolhidos: produtos })}
                                            setValorTotal={(valor) => this.setState({ valorTotal: valor })}
                                            produtosEscolhidos={this.state.produtosEscolhidos}
                                            valorTotal={this.state.valorTotal}
                                            maxValue={this.state.saldoAtual}
                                            produtos={this.state.produtos}
                                        />
                                        <hr />
                                        <div className='form_produtos_lista_item bold'>
                                            <div>Total</div>
                                            <div>R$ {Util.formatarDinheiro(this.state.valorTotal)}</div>
                                        </div>
                                    </div>
                                    {this.state.tipo === "USUARIO" &&
                                        <div className='col-12 contcard last_field'>
                                            <span>Usuário *</span>

                                            <Select placeholder="Selecione o usuário do voucher" value={this.state.usuariosOptions.find((opt) => opt.value === this.state.usuario)} options={this.state.usuariosOptions.filter(this.filterOptions).splice(0, 25)} onChange={a => { this.setState({ usuario: a.value }); }} onInputChange={(a) => this.setState({ textOptions: a })} />
                                            <span>Não Selecionado</span>
                                        </div>
                                    }
                                </>
                            }
                            <div className='col-12 contvtt display_row_spaced'>
                                <button type='button' className="button_salvar" disabled={!validForm} onClick={() => validForm ? this.saveVoucher() : {}}>Salvar</button>

                                {this.state.loading && <Squares color={'black'} size={40} speed={0.5} />}
                            </div>
                        </div>


                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        cnpj_cpf: user.cnpj_cpf,
        nome: user.nome,
        empresa: user.empresa,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddVoucher)